import React from "react";
export var LeadlogsSidebar = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "leadlog-sidebar-body" },
            React.createElement("div", { className: "DMsanR_11_400 txt-thick_grey leadlog-time" }, props.datetime),
            React.createElement("div", { className: "DMSansNormal_13_400 txt_blackOne1 leadlog-text" }, props.leadtext))));
};
